import { Box, Stack } from "@mui/system";
import RawDataTable from "./RawDataTable";
import ViewListIcon from "@mui/icons-material/ViewList";
import { Chip, Typography } from "@mui/material";

const chipSx = {
  height: 20,
  borderRadius: "5px",
  fontSize: "12px",
  color: "#00000099",
  borderColor: "#BDBDBD",
  bgcolor: "#FAFAFA",
  "& .MuiChip-label": {
    px: 0.5,
  },
};


const tableHeadings = {
  created_timestamp: "Created (Timestamp)",
  player_id: "Player ID",
  commission_earned: "Commission earned (cumulative GBP)",
};
const rows = [
  {
  created_timestamp: "01/05/2026 00:01",
  player_id: "-",
  commission_earned: "41,820.00",
  currency : "GBP",
  },
  {
  created_timestamp: "02/05/2026 05:45",
  player_id: "-",
  commission_earned: "43,020.00",
  currency : "USD",
  }
];

const RawData = () => {
  return (
    <>
      <Box px={2} py={1} flexDirection={'row'}>
        <Stack direction="row" spacing={1} mb={2}>
          <ViewListIcon sx={{color:"#00000061"}} />
          <Box>
            <Typography fontSize={14} fontWeight={500} mb={1} color="#000000DE">
              Showing Sample Records
            </Typography>
            <Stack direction="row" spacing={1}>
              <Chip
                label="Table: raw_data_993"
                variant="outlined"
                sx={chipSx}
              />
              <Chip
                label="Source Field: Commission earned"
                variant="outlined"
                sx={chipSx}
              />
            </Stack>
          </Box>
        </Stack>
        <RawDataTable tableHeadings={tableHeadings} rows={rows} />
      </Box>
    </>
  );
};

export default RawData;
